export default (string = '', toLower = false) => {
  if (string && typeof string === 'string') {
    let norm = string.replace(/[^a-zA-Z ]/g, '')
    if (toLower) norm = norm.toLowerCase()
    return norm
  }

  return ''
}
